import axios from "axios";
import {
  All_Company_Request,
  All_Company_Success,
  All_Company_Failed,
} from "../../../redux/reduser/Company&User/AllCompanys";
import { GetTokenFunc } from "../../../utils/GetToken";

import {
  Category,
  CompanyStatus,
  Membership,
  Page,
  SelectedCompany,
  DateFilter,
  CompanyListingSearch,
  CalendarStartingDate,
  CalendarEndingDate,
} from "../../../components/Company/CompanyListing";
import { getCompanyListingCohort } from "../../../constants/companyListingCohort";

export const AllCompanysDetails =
  (categoryArg, statusArg, membershipArg, pageArg) => async (dispatch) => {
    try {
      dispatch({ type: All_Company_Request.toString() });
      const cohort = encodeURIComponent(getCompanyListingCohort() || "");

      const cat =
        categoryArg !== undefined && categoryArg !== null
          ? String(categoryArg)
          : String(Category ?? "");
      const st =
        statusArg !== undefined && statusArg !== null
          ? String(statusArg)
          : String(CompanyStatus ?? "");
      const mem =
        membershipArg !== undefined && membershipArg !== null
          ? String(membershipArg)
          : String(Membership ?? "");
      const pageNum =
        pageArg !== undefined && pageArg !== null && pageArg !== ""
          ? String(pageArg)
          : String(Page ?? "1");

      const { data } = await axios.get(
        `/api/v1/admin/GetAllCompanys?CompanyCategoty=${encodeURIComponent(
          cat
        )}&CompanyStatus=${encodeURIComponent(
          st
        )}&Membership=${encodeURIComponent(
          mem
        )}&SelectedCompany=${encodeURIComponent(
          SelectedCompany ?? ""
        )}&DateFilter=${encodeURIComponent(
          DateFilter ?? ""
        )}&StartingDate=${encodeURIComponent(
          CalendarStartingDate ?? ""
        )}&EndingDate=${encodeURIComponent(
          CalendarEndingDate ?? ""
        )}&page=${pageNum}&Search=${encodeURIComponent(
          CompanyListingSearch ?? ""
        )}&CompanyCohort=${cohort}`,
        {
          withCredentials: true,
          headers: {
            authorization: `Bearer ${GetTokenFunc()}`,
          },
        }
      );

      dispatch({
        type: All_Company_Success.toString(),
        payload: data,
      });
    } catch (error) {
      dispatch({
        type: All_Company_Failed.toString(),
        payload: error?.response?.data?.message,
      });
    }
  };
